import { makeStyles } from "tss-react/mui";

export const useButtonTextStyles = makeStyles()(() => ({
    buttonTextType: {
        display: "flex",
        color: "unset",
    },
}));
